/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');

      if (!this.hasAttribute('aria-label')) {
        const itemTitle = this.closest('[id^="CartItem-"]')
          ?.querySelector('a[href*="/products/"]')
          ?.textContent
          ?.trim();
        this.setAttribute(
          'aria-label',
          itemTitle ? `${itemTitle} aus dem Warenkorb entfernen` : 'Artikel aus dem Warenkorb entfernen'
        );
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}

if (!window.cartRemoveDelegationInitialized) {
  window.cartRemoveDelegationInitialized = true;

  const removeCartItem = (removeButton, event) => {
    event.preventDefault();
    const index = removeButton.dataset.index;
    const cartDrawer = removeButton.closest('cart-drawer');

    if (cartDrawer) {
      cartDrawer.updateQuantity(index, '0');
    } else {
      document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index } }));
    }
  };

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('cart-remove');
    if (removeButton) removeCartItem(removeButton, event);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const removeButton = event.target.closest('cart-remove');
    if (removeButton) removeCartItem(removeButton, event);
  });
}
